module.exports = __webpack_public_path__ + "25-o2.jpg?828cde90c37ff8b5458e2abed0fb2d8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/25-o2.jpg
// module id = 651
// module chunks = 0